import * as questionIds from "../../consultationQuestions/questionIds";

export const urinalysisQuestions = [
    {
        id: questionIds.UrinalysisUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.UrinalysisUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.UrinalysisProtein,
        questionText: "Protein",
    },
    {
        id: questionIds.UrinalysisGlucose,
        questionText: "Glucose",
    },
    {
        id: questionIds.UrinalysisBlood,
        questionText: "Blood",
    },
    {
        id: questionIds.UrinalysisSelfReferralLetterIssued,
        questionText: "GP Self-Referral Letter issued?",
    }
];
